// extracted by mini-css-extract-plugin
export default {"statistic-card":"ResumedStatisticCard_statistic-card__LVHik"};